/** Admin: sales requests list, invoiced (manual) billing of one workspace, and the custom (Institution) plan terms (DEC-155). */
export const salesRequests = {
  title: "Sales requests",
  subtitle: "What workspaces asked sales for. Contact them, then assign the plan and add-ons on their Billing tab.",
  search: "Search workspace or contact",
  filters: { all: "All", new: "New", contacted: "Contacted", done: "Done" },
  statuses: { new: "New", contacted: "Contacted", done: "Done" },
  status: "Status",
  ref: "Request",
  workspace: "Workspace",
  wanted: "Wanted",
  terms: "Cycle and seats",
  contact: "Contact",
  received: "Received",
  notes: "Their notes",
  plan: "{{plan}} plan",
  addonsOnly: "Add-ons only",
  seats: "{{count}} seats",
  cycles: { monthly: "Monthly", annual: "Annual" },
  emptyTitle: "No sales requests here",
  emptyBody: "When a workspace asks to pay another way or talk to sales, the request appears here.",
  emptySearch: "No request matches that search.",
  review: {
    action: "Review",
    title: "Sales request SR-{{number}}",
    staffNote: "Staff note",
    staffNoteHint: "Only platform staff see this.",
    save: "Save",
    saved: "SR-{{number}} updated",
    assign: "Assign plan and add-ons",
  },
} as const;

export const manualBilling = {
  badge: "Billed by invoice",
  card: "Invoiced term",
  term: "Term",
  agreedPrice: "Agreed plan price",
  catalogPrice: "Catalogue price",
  staffNote: "Staff note",
  addons: "Add-ons",
  none: "None",
  assign: "Assign invoiced plan",
  edit: "Edit invoiced term",
  handBack: "Hand back to self-serve",
  handBackTitle: "Hand back to self-serve billing?",
  handBackBody: "The plan, add-ons and dates stay. At the end date the normal renewal runs: the saved PayPal account is charged, or the owner is asked to pay.",
  handBackDone: "Handed back to self-serve billing",
  neverCharged: "Never charged automatically. The admin is reminded before the end date.",
  dialogTitle: "Invoiced plan for {{tenant}}",
  dialogBody: "Billing is manual: Sagot invoices outside the product and nothing is charged. Plan and add-on features apply at once.",
  plan: "Plan",
  cycle: "Billing cycle",
  monthly: "Monthly",
  annual: "Annual",
  startsOn: "Start date",
  endsOn: "End or renewal date",
  price: "Agreed price for the plan (optional)",
  priceHint: "Blank uses the catalogue price. Shown to the workspace as the agreed price.",
  addonsLegend: "Add-ons for this term",
  addonsHint: "This is the complete list: a running add-on that is not ticked ends now.",
  quantity: "Units of {{name}}",
  note: "Note (staff only)",
  noteHint: "Invoice number, contract reference, anything the team needs.",
  save: "Save invoiced term",
  saved: "Invoiced term saved",
  loadError: "We couldn't load the plans and add-ons.",
  datesOrder: "The end date must be after the start date.",
} as const;

export const customPlan = {
  title: "Institution terms",
  body: "Institution has no list price, so it is billed by invoice. The workspace keeps these limits until you change them.",
  invoiced: "Billing mode: manual / invoiced. Nothing is charged automatically.",
  price: "Custom price per month (optional)",
  priceHint: "Leave blank or 0 for a manual invoice with no stated price.",
  limitsLegend: "Limits",
  messages: "Messages per month",
  agents: "Agents",
  seats: "Seats",
  storage: "Knowledge storage (GB)",
  unlimited: "Unlimited",
  unlimitedFor: "Unlimited {{limit}}",
  note: "Note (staff only)",
  scheduled: "Institution is scheduled for the next renewal",
  appliedNow: "{{plan}} is now billed by invoice",
  invalid: "Enter a whole number, or tick Unlimited.",
  invalidPrice: "Enter a price of 0 or more.",
} as const;
